import React from "react";
import { defineMessages } from "react-intl";
import { ListInspect } from "cci-component";
import { Route } from "cci-utility";
import { PrimaryPage } from "cci-admin";
import List from "../view/office/List";
import Inspect from "../view/office/Inspect";

const messages = defineMessages({
  officePlaceholder: {
    id: "officePlaceholder",
    defaultMessage: "Select an office to see its detail."
  }
});

/**
 * List / Inspect Page for the Office entity.
 *
 * This page allows to create, update and search for offices.
 */
const OfficesPage = () => (
  <PrimaryPage>
    <ListInspect
      rootPath="/offices"

      left={List}

      placeholderMessage={messages.officePlaceholder}
      selectionPath="/offices/:id"
      right={Inspect}
    />
  </PrimaryPage>
);

export default OfficesPage;
